<template>
  <div class="doctors">
    <h5
      class="svg-upper speciality shadow-sm bg-white mb-2"
      v-if="speciality && specialityById(speciality)"
    >
      <router-link
        class="nounderline d-flex justify-content-between px-3 py-3 svg-sm"
        to="doctors"
      >
        <strong>{{ specialityById(speciality).name[authLocale] }}</strong>
        <CloseIcon></CloseIcon>
      </router-link>
    </h5>
    <div class="filters d-flex flex-nowrap bg-white mb-2" v-else>
      <input
        type="text"
        ref="filter-input"
        class="filter px-3"
        v-model="query"
        @focus="filterOpen = true"
        :placeholder="$t('chooseSpeciality')"
      />
      <span
        class="angle pointer"
        :class="{ open: filterOpen }"
        @click.prevent="toggleFilterOpen"
      >
        <AngleIcon></AngleIcon>
      </span>
      <div
        class="specialities shadow-sm flex-column"
        :class="{ open: filterOpen }"
      >
        <router-link
          v-for="s of specialities"
          :key="s.id"
          class="text-nowrap nounderline px-3 py-2"
          :to="`/doctors?speciality=${s.id}`"
        >
          {{ s.name[authLocale] }}
        </router-link>
      </div>
    </div>

    <h5
      v-if="$route.query.interview"
      class="svg-upper svg-sm symptom-checker-btn shadow-sm bg-white mb-2 p-3 pointer"
    >
      <router-link
        :to="`/symptom-checker/${$route.query.interview}`"
        class="nounderline"
      >
        <SymptomCheckerIcon></SymptomCheckerIcon>
        {{ $t('returnToInterview') }}
      </router-link>
    </h5>
    <div class="mb-2" v-else>
      <CheckSymptoms size="sm"></CheckSymptoms>
    </div>
    <div v-for="d of doctors" :key="d.id" class="bg-white mb-2 py-2">
      <DoctorInfo
        :doctor="d"
        :service-tags="true"
        :interview-id="$route.query.interview"
      ></DoctorInfo>
      <!-- <doctor
        :doctor="d"
        :key="d.id"
        :interview-id="$route.query.interview"
      ></doctor> -->
    </div>
    <LoadingMore v-if="loading"></LoadingMore>
    <a
      v-else-if="more"
      @click.prevent="loadMore"
      class="pointer d-block bg-primary text-white text-center py-2 mb-4"
    >
      <small>{{ $t("loadMore") }}</small>
    </a>
  </div>
</template>
<script>
import { mapMutations, mapGetters } from 'vuex'
import DoctorInfo from '@/components/DoctorInfo.vue'
import LoadingMore from '@/components/Loadings/More'
import CloseIcon from '@/components/Icons/Close'
import AngleIcon from '@/components/Icons/Angle'
import SymptomCheckerIcon from '@/components/Icons/SymptomChecker'
import CheckSymptoms from '@/components/CheckSymptoms'
export default {
  components: {
    DoctorInfo,
    LoadingMore,
    CloseIcon,
    AngleIcon,
    SymptomCheckerIcon,
    CheckSymptoms
  },
  metaInfo: {
    title: 'Doctors'
  },
  data () {
    return {
      loading: true,
      offset: 0,
      limit: 5,
      speciality: null,
      query: '',
      filterOpen: false,
      more: true
    }
  },
  computed: {
    ...mapGetters({
      authLocale: 'auth/locale',
      authUser: 'auth/user',
      doctors: 'doctor/doctors',
      allSpecialities: 'speciality/specialities',
      specialityById: 'speciality/byId',
      scrolledToBottom: 'app/scrolledToBottom'
    }),
    specialities () {
      const ret = []
      for (const s of this.allSpecialities) {
        if (this.query === '') {
          ret.push(s)
          continue
        }
        if (s.name[this.authLocale].indexOf(this.query) !== -1) {
          ret.push(s)
        }
      }
      return ret
    }
  },
  watch: {
    '$route.query.speciality' () {
      this.speciality = this.$route.query.speciality
      this.offset = 0
      this.limit = 5
      this.resetDoctors()
      this.fetch()
    }
  },
  mounted () {
    this.fetchSchedules()
    this.speciality = this.$route.query.speciality
    this.fetch()
  },
  destroyed () {
    this.setRedirect(null)
    this.resetDoctors()
  },
  methods: {
    ...mapMutations({
      setRedirect: 'auth/setRedirect',
      setAlert: 'alert/setAlert',
      setDoctor: 'doctor/set',
      resetDoctors: 'doctor/reset',
      setSchedule: 'schedule/set',
      setChat: 'chat/set'
    }),
    loadMore () {
      this.offset = this.limit + this.offset
      this.fetch()
    },
    toggleFilterOpen () {
      if (this.filterOpen) {
        this.$refs['filter-input'].blur()
        this.filterOpen = !this.filterOpen
      } else {
        this.$refs['filter-input'].focus()
      }
    },
    async fetch () {
      this.loading = true
      let url = '/guest/doctors'
      let list = 'guest'
      if (this.authUser) {
        list = 'patient'
        url = '/api/patient/doctors'
      }
      try {
        const params = {
          offset: this.offset,
          limit: this.limit
        }
        if (this.speciality) {
          params.speciality_ids = [this.speciality]
        }
        const response = await this.axios.get(url, {
          params
        })
        const doctors = response.data.data
        let i = this.offset
        for (const doctor of doctors) {
          i++
          this.setDoctor({
            id: doctor.id,
            firstname: doctor.firstname,
            lastname: doctor.lastname,
            busy: doctor.busy,
            speciality_id: doctor.speciality_id,
            title: doctor.title,
            experience_from: doctor.experience_from,
            chat: doctor.chat_space,
            clinic_services: doctor.clinic_services,
            photo: doctor.photo,
            country: doctor.country,
            gender: doctor.gender,
            birthdate: doctor.birthdate,
            language: doctor.language,
            languages: doctor.languages,
            email: doctor.email_address,
            phone: doctor.phone_number
          })
          this.$ga.ecommerce.addImpression({
            id: doctor.id,
            name: `${doctor.firstname.en} ${doctor.lastname.en}`,
            category: 'Doctor',
            list: list,
            position: i
          })
          if (doctor.chat_space) {
            this.setChat({
              chat_space: doctor.chat_space,
              id: doctor.chat_space.id,
              last_message: doctor.chat_space.last_message,
              last_seen: doctor.chat_space.last_seen,
              type: 'PatientDoctor'
            })
          }
        }
        if (doctors.length < this.limit) {
          this.more = false
        }
        this.loading = false
      } catch (err) {
        this.setAlert({
          message: err,
          type: 'danger'
        })
        this.loading = false
      }
    },
    async fetchSchedules () {
      if (!this.authUser) {
        return
      }
      try {
        const params = {
          offset: 0,
          limit: 10,
          statuses: ['pending', 'payment_required', 'completed']
        }
        const response = await this.axios.get('/api/schedules/upcoming', {
          params
        })
        const schedules = response.data.data
        for (const schedule of schedules) {
          this.setSchedule({
            id: schedule.id,
            city_id: schedule.city_id,
            address: schedule.address,
            patient_id: schedule.patient_id,
            patient: schedule.patient,
            clinic_service_id: schedule.clinic_service_id,
            clinic_service: schedule.clinic_service,
            clinic_id: schedule.clinic_id,
            service_id: schedule.service_id,
            assignee_id: schedule.assignee_id,
            assignee: schedule.assignee,
            communication_days: schedule.communication_days,
            start_time: schedule.start_time,
            status: schedule.status,
            price: schedule.price,
            comment: schedule.comment,
            interview_id: schedule.interview_id,
            interview_status: schedule.interview_status,
            patient_case_id: schedule.patient_case_id,
            created_at: schedule.created_at,
            created_by: schedule.created_by
          })
        }
      } catch (err) {
        this.setAlert({
          message: err,
          type: 'danger'
        })
      }
    }
  }
}
</script>
<style lang="scss">
.doctors {
  background-color: #eee;
  min-height: 100%;
  .speciality {
    position: sticky;
    top: 0px;
    z-index: 1111;
    font-size: 1em;
  }
  .symptom-checker-btn {
    padding: 16px 0 13px;
    font-size: 0.8em;
    color: #5a95ce;
  }
  .filters {
    position: sticky;
    top: 0px;
    z-index: 1111;
    .filter {
      border: none;
      box-shadow: none;
      outline: none;
      width: 100%;
      z-index: 112;
      font-family: "BPG SuperSquare Mtavruli", SFProText, Helvetica;
      font-size: 0.8em;
      padding: 16px 0 13px;
    }
    .angle {
      svg {
        position: absolute;
        z-index: 113;
        width: 24px;
        height: 24px;
        top: calc(50% - 12px);
        right: 16px;
        color: #3c88ff;
        transition: all 0.2s ease;
      }
      &.open {
        svg {
          transform: rotate(180deg);
        }
      }
    }
    .specialities {
      width: 100%;
      background-color: #fff;
      font-size: 0.8em;
      position: absolute;
      max-height: calc(100vh - 183px);
      top: calc(-100vh + 183px);
      overflow: auto;
      border-top: 1px solid #eee;
      transition: all 0.3s ease;
      z-index: 1111;
      a {
        display: block;
        border-bottom: 1px solid #eee;
      }
      &.open {
        top: 48px;
      }
    }
  }
}
</style>
<i18n>
{
  "ka": {
    "chooseSpeciality": "აირჩიე სპეციალობა",
    "loadMore": "მეტის ჩატვირთვა",
    "returnToInterview": "ინტერვიუზე დაბრუნება",
    "orFillOutQuestionnaire": "ან შეავსე კითხვარი"
  },
  "en": {
    "chooseSpeciality": "Choose Speciality",
    "loadMore": "Load More",
    "returnToInterview": "Return to Interview",
    "orFillOutQuestionnaire": "Or fill out Questionnaire"
  }
}
</i18n>
